import React from "react";
import MainLayout from "../../../components/Layouts";
import ShippingAddRateList from "../../../components/Shop/DeliveryShipping/AddRate";

const DeliveryShippingAddRatePage = () => {
  return (
    <MainLayout>
      <ShippingAddRateList />
    </MainLayout>
  );
};

export default DeliveryShippingAddRatePage;
